if (!customElements.get('complementary-products-list')) {
  customElements.define('complementary-products-list', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected) this.init();
      });
    }

    init() {
      if (this.initialized) return;
      this.viewport = this.querySelector('.complementary-list__viewport');
      this.list = this.viewport?.querySelector(':scope > ul');
      this.button = this.querySelector('.complementary-list__toggle');
      this.controls = this.querySelector('.complementary-list__controls');
      if (!this.list || !this.button || !this.controls) return;

      this.items = Array.from(this.list.children);
      this.initialCount = Number(this.dataset.initialCount) || 3;
      if (this.items.length <= this.initialCount) return;

      this.initialized = true;
      this.expanded = false;
      this.label = this.button.querySelector('[data-complementary-label]');
      this.handleClick = () => {
        this.expanded = !this.expanded;
        this.update();
        if (!this.expanded) {
          this.scrollHandler = (event) => {
            if (event.target !== this.viewport || event.propertyName !== 'height') return;
            this.viewport.removeEventListener('transitionend', this.scrollHandler);
            const bounds = this.button.getBoundingClientRect();
            if (bounds.top < 0 || bounds.bottom > window.innerHeight) {
              this.button.scrollIntoView({ block: 'nearest', behavior: 'auto' });
            }
          };
          this.viewport.addEventListener('transitionend', this.scrollHandler);
        }
      };

      this.button.addEventListener('click', this.handleClick);
      this.controls.hidden = false;
      this.classList.add('complementary-list--enhanced');
      this.update();

      this.resizeObserver = new ResizeObserver(() => this.updateHeight());
      this.resizeObserver.observe(this.list);
      this.items.slice(0, this.initialCount).forEach((item) => this.resizeObserver.observe(item));
    }

    update() {
      this.dataset.expanded = String(this.expanded);
      this.button.setAttribute('aria-expanded', String(this.expanded));
      this.label.textContent = this.expanded ? this.button.dataset.less : this.button.dataset.more;
      this.items.slice(this.initialCount).forEach((item) => {
        item.inert = !this.expanded;
        if (this.expanded) {
          item.removeAttribute('aria-hidden');
        } else {
          item.setAttribute('aria-hidden', 'true');
        }
      });
      this.updateHeight();
    }

    updateHeight() {
      if (!this.isConnected) return;
      const top = this.viewport.getBoundingClientRect().top;
      const bottom = this.expanded
        ? this.list.getBoundingClientRect().bottom
        : this.items[this.initialCount - 1].getBoundingClientRect().bottom + 36;
      this.viewport.style.height = Math.ceil(bottom - top) + 'px';
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.button?.removeEventListener('click', this.handleClick);
      if (this.scrollHandler) this.viewport?.removeEventListener('transitionend', this.scrollHandler);
      this.initialized = false;
    }
  });
}
